import { combineEpics, ofType } from 'redux-observable'
import { EMPTY, merge, of } from 'rxjs'
import { catchError, delay, mergeMap, takeUntil } from 'rxjs/operators'

import { COMMON_ERROR } from 'utils/ErrorMessages'

import { addToast } from 'containers/Toasts/actions'

import { fetchData as fetchMailboxes } from '../actions'
import { selectTypeFilter } from '../selectors'

import { removeTagError, removeTagSuccess, toggleStatusError, toggleStatusSuccess } from './actions'
import { STATUS_TOGGLE_ASYNC, TAG_REMOVE_ASYNC } from './constants'

const toggleStatusEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(STATUS_TOGGLE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.mailboxes
        .toggleStatus(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload.id,
          action.payload.status
        )
        .pipe(
          mergeMap(({ response }) => {
            const typeFilter = selectTypeFilter(state$.value)
            // we want to dispatch a fetching because we want to show only enabled or disabled mailboxes.
            // without timeout the loader will unmount the tableRow and cancel this call
            const refetch$ =
              typeFilter === 'enabled' || typeFilter === 'disabled'
                ? of(fetchMailboxes()).pipe(delay(1000))
                : EMPTY

            const result$ = response.success
              ? of(toggleStatusSuccess(response))
              : of(
                  toggleStatusSuccess(response),
                  addToast({
                    message: response.message,
                    type: 'error',
                  })
                )

            return merge(result$, refetch$)
          }),
          catchError((error) =>
            of(
              epicsErrorHandler(toggleStatusError, error),
              addToast({
                message: COMMON_ERROR,
                type: 'error',
              })
            )
          ),
          takeUntil(action$.pipe(ofType(STATUS_TOGGLE_ASYNC.CANCEL)))
        )
    )
  )

const tagRemoveEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(TAG_REMOVE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.mailboxes
        .removeTags(state$.value.partnerOptions.selectedCompany?.value, {
          profileIds: [action.payload.id],
          tagNames: [action.payload.tagName],
          oneTagMode: true,
        })
        .pipe(
          mergeMap(({ response }) => of(fetchMailboxes(), removeTagSuccess(response))),
          catchError((error) => of(epicsErrorHandler(removeTagError, error)))
        )
    )
  )

export default combineEpics(toggleStatusEpic, tagRemoveEpic)
